// removed by extract-text-webpack-plugin
module.exports = {"fill":"nrk-v17-static-fill","fill--r":"nrk-v17-static-fill--r","fill--sv":"nrk-v17-static-fill--sv","fill--ap":"nrk-v17-static-fill--ap","fill--sp":"nrk-v17-static-fill--sp","fill--mdg":"nrk-v17-static-fill--mdg","fill--krf":"nrk-v17-static-fill--krf","fill--v":"nrk-v17-static-fill--v","fill--h":"nrk-v17-static-fill--h","fill--frp":"nrk-v17-static-fill--frp","fill--andre":"nrk-v17-static-fill--andre","fill--ingen":"nrk-v17-static-fill--ingen"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/parti.css
// module id = 242
// module chunks = 0 1 2 3 6 7